module.exports = __webpack_public_path__ + "static/media/CSV.0b434025.svg";